import React from 'react';
import PropTypes from 'prop-types';
import socialSpriteImgUrl from '../../images/footer/social-sprite.svg';

const SocialList = ({ className, iconsList }) => (
	<ul className={` flex space-x-3  ${className || ''}`}>
		{iconsList.map(({ title, imgUrl, url, target }, index) => (
			<li key={index}>
				<a
					className='block text-gray-500 hover:text-white bg-gray-300 hover:bg-primary-dark transition duration-300 ease-in-out rounded'
					href={url}
					target={target}
					rel='noreferrer'
				>
					<svg
						aria-label={`${title} icon`}
						className='w-9 h-9 p-2 block  fill-current '
					>
						<use href={`${`${socialSpriteImgUrl}#${imgUrl}`}`} />
					</svg>
				</a>
			</li>
		))}
	</ul>
);

export default SocialList;
SocialList.propTypes = {
	className: PropTypes.string,
	iconsList: PropTypes.array,
};
